import { render, staticRenderFns } from "./trainDetail.vue?vue&type=template&id=62cdc2ec&scoped=true&"
import script from "./trainDetail.vue?vue&type=script&lang=js&"
export * from "./trainDetail.vue?vue&type=script&lang=js&"
import style0 from "./trainDetail.vue?vue&type=style&index=0&id=62cdc2ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cdc2ec",
  null
  
)

export default component.exports